<template>
  <loan-status-alert-container :loan="loan">
    <template v-if="loan.loanable.type === 'car'" #borrower>
      <h4 class="mt-0">
        {{ $t("loans.insurance_warning.title") }}
      </h4>

      <i18n path="loans.insurance_warning.warning" tag="p">
        <template #link>
          <a :href="$t('conditions.insurance_conditions_url')" target="_blank">{{
            $t("conditions.insurance_conditions_name")
          }}</a>
        </template>
        <template #emphasis>
          <strong>
            {{ $t("loans.insurance_warning.car_stays_in_quebec") }}
          </strong>
        </template>
      </i18n>
    </template>
  </loan-status-alert-container>
</template>

<script>
import LoanStatusAlertContainer from "@/components/Loan/Status/Alerts/LoanStatusAlertContainer.vue";
import { isBorrower } from "@/helpers/permissions/loans";

export default {
  name: "NewLoan",
  components: {
    LoanStatusAlertContainer,
  },
  props: {
    loan: {
      type: Object,
      required: true,
    },
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    isBorrower() {
      return isBorrower(this.user, this.loan);
    },
  },
};
</script>

<style lang="scss"></style>
